import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightbulb20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.75 7.5C2.75 3.15388 6.19308 0.25 9.99997 0.25C13.8068 0.25 17.25 3.15387 17.25 7.5C17.25 8.41861 16.9436 9.26194 16.5368 10.0248C16.1371 10.7741 15.6114 11.497 15.1226 12.1691L15.1066 12.1911C14.5999 12.8878 14.1327 13.5323 13.7868 14.1811C13.4436 14.8244 13.25 15.4186 13.25 16V19C13.25 19.4142 12.9142 19.75 12.5 19.75H7.5C7.08579 19.75 6.75 19.4142 6.75 19V16C6.75 15.4186 6.55637 14.8244 6.21324 14.1811C5.86725 13.5323 5.4001 12.8878 4.89345 12.1911L4.87741 12.1691C4.38858 11.497 3.86288 10.7741 3.46324 10.0248C3.05637 9.26194 2.75 8.41861 2.75 7.5ZM9.99997 1.75C6.94972 1.75 4.25 4.05232 4.25 7.5C4.25 8.08139 4.44363 8.67556 4.78676 9.31893C5.13275 9.96766 5.5999 10.6122 6.10655 11.3089L6.12259 11.3309C6.61141 12.003 7.13713 12.7259 7.53676 13.4752C7.8303 14.0256 8.07153 14.6178 8.18314 15.25H9.25V10.793C9.20337 10.7579 9.15863 10.7192 9.11619 10.6767L6.96973 8.53034L8.03037 7.46967L10.0001 9.43929L11.9697 7.46967L13.0304 8.53034L10.8839 10.6767C10.8414 10.7192 10.7967 10.758 10.75 10.7931V15.25H11.8169C11.9285 14.6178 12.1697 14.0256 12.4632 13.4752C12.8629 12.7259 13.3886 12.003 13.8774 11.3309L13.8934 11.3089C14.4001 10.6122 14.8673 9.96766 15.2132 9.31893C15.5564 8.67556 15.75 8.08139 15.75 7.5C15.75 4.05233 13.0502 1.75 9.99997 1.75ZM11.75 16.75H8.25V18.25H11.75V16.75Z'
      fill='currentColor'
    />
  </Svg>
);

Lightbulb20.displayName = 'Lightbulb20';
export default Lightbulb20;
